import VolumeMutedIcon from '@atlaskit/icon/core/volume-muted';
import * as React from 'react';

export function SvgVolumeX() {
  return <VolumeMutedIcon label="" testId="ads-refreshed-icon" />;
}
